import styled from "styled-components";

const StyledInput = styled.input`
  font-family: "Open Sans", sans-serif;
  width: 100%;
  box-sizing: border-box;
  padding: 0.625rem 0.625rem;     // ~10px
  margin: 0.625rem 0;             // ~10px
  border: 1px solid #ccc;
  border-radius: 0.3125rem;       // ~5px
  font-size: 1rem;                // 16px base
  &:focus {
    outline: none;
    border-color: #076633;
  }
`;

export const InputLogin = ({ value, onChange, placeholder, type = "text", ...rest }) => {
  return (
    <StyledInput
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      {...rest}
    />
  );
};
